import { render, staticRenderFns } from "./dimensionsWindow.vue?vue&type=template&id=4e900e14&scoped=true&"
import script from "./dimensionsWindow.vue?vue&type=script&lang=js&"
export * from "./dimensionsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e900e14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e900e14')) {
      api.createRecord('4e900e14', component.options)
    } else {
      api.reload('4e900e14', component.options)
    }
    module.hot.accept("./dimensionsWindow.vue?vue&type=template&id=4e900e14&scoped=true&", function () {
      api.rerender('4e900e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FrontEndWarehouse/components/warehousing/dimensionsWindow.vue"
export default component.exports